import React, { Fragment, useState } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { subscriberData } from "../PageComponents/index";
import SubscriptionCard from "../PageComponents/SubscriptionCard";
import { useNavigate } from "react-router-dom";
import { updatePlan } from "../../../../../api-handle/subscriptionApi";

const SubscriptionPlans = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReactiveModalOpen, setIsReactiveModalOpen] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [refetch, setRefetch] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState(null); // 🔹 store status

  const handleDeactivateClick = (id, status) => {
    setSelectedPlanId(id);
    setSelectedStatus(status); // 🔹 save current status

    if (status === "inactive") {
      setIsReactiveModalOpen(true);
    }
    if (status === "active") {
      setIsModalOpen(true);
    }
  };

  // Confirm activation/deactivation
  const confirmDeactivation = async () => {
    try {
      if (selectedPlanId && selectedStatus) {
        const newStatus = selectedStatus === "active" ? "inactive" : "active"; // 🔹 toggle status

        await updatePlan(selectedPlanId, { status: newStatus });
        setRefetch(!refetch);

      }
    } catch (error) {
      console.error("Error updating plan status:", error);
    }

    setIsModalOpen(false);
    setIsReactiveModalOpen(false);
  };

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Subscription Plans" parent="Subscription Management" title="Manage Plans" />
      <Container fluid={true}>
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <Button color="primary" onClick={() => navigate("/subscription/add-edit")}>
                  Add New Plan
                </Button>
              </CardHeader>
              <CardBody>
                <SubscriptionCard
                  data={subscriberData}
                  onEdit={(id) => navigate(`/subscription/add-edit/${id}`)}
                  onDeactivate={handleDeactivateClick}
                  refetch={refetch}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Deactivation Confirmation Modal */}
      <Modal isOpen={isModalOpen} centered toggle={() => setIsModalOpen(!isModalOpen)}>
        <ModalHeader toggle={() => setIsModalOpen(false)}>Confirm Deactivation</ModalHeader>
        <ModalBody>Are you sure you want to deactivate this subscription plan?</ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDeactivation}>Yes, Deactivate</Button>
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={isReactiveModalOpen} centered toggle={() => setIsReactiveModalOpen(!isReactiveModalOpen)}>
        <ModalHeader toggle={() => setIsReactiveModalOpen(false)}>Confirm Reactivation</ModalHeader>
        <ModalBody>Are you sure you want to reactivate this subscription plan?</ModalBody>
        <ModalFooter>
          <Button color="success" onClick={confirmDeactivation}>Yes, Reactivate</Button>
          <Button color="secondary" onClick={() => setIsReactiveModalOpen(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default SubscriptionPlans;
